<script>
import { defineComponent } from 'vue'
import SquareButton from '../../content/common/squareButton.vue'

export default defineComponent({
    name: 'dashlet-card',
    components: { SquareButton },
    props: {
        title: {
            type: String,
            required: true
        },
        chipText: String,
        chipClickable: Boolean,
        pageHref: String,
        pageTooltip: String
    }
})
</script>

<template>
    <div class="dashlet-card elevation-4">
        <div class="dashlet-title-container py-2">
            <span>{{ title }}</span>

            <v-chip v-if="chipText"
                    color="primary"
                    label
                    small
                    text-color="white"
                    @[chipClickable?`click`:null]="$emit('chipClick')">
                {{ chipText }}
            </v-chip>

            <slot name="append" />

            <v-spacer v-if="pageHref" />

            <slot name="prependButton" />

            <square-button v-if="pageHref"
                           :href="pageHref"
                           :tooltip-text="pageTooltip"
                           flat
                           icon="fal fa-square-arrow-up-right" />
        </div>

        <div class="dashlet-content">
            <slot name="default" />
        </div>
    </div>
</template>
